<template>
    <el-dialog :title="$t('serviceTickets.sendAsEmail')"              
               width="40%"
               :visible.sync="showDialog"
               loadingChangeEmail="loadingChangeEmail"
               formChangeEmail="formChangeEmail"
               append-to-body
               :close-on-click-modal="false">
        <el-dialog :visible.sync="showChangeEmailDialog"
                   width="40%"
                   append-to-body
                   :close-on-click-modal="false">
            <el-form v-loading="loadingChangeEmail"
                     ref="formChangeEmail"
                     :model="formChangeEmail"
                     :rules="rulesChangeEmail"
                     size="small"
                     label-width="140px"
                     label-position="left">
                <el-form-item :label="$t('serviceTickets.serviceCompany')"
                              prop="serviceCompany">
                    <el-input v-model="formChangeEmail.serviceCompany"
                              :disabled="!formChangeEmail.useCustom"></el-input>
                </el-form-item>
                <el-form-item :label="$t('serviceTickets.phone')"
                              prop="phone">
                    <el-input v-model="formChangeEmail.phone" v-mask="'(###) ###-####'"
                              :disabled="!formChangeEmail.useCustom"></el-input>
                </el-form-item>
                <el-form-item :label="$t('serviceTickets.email')"
                              prop="email">
                    <el-input v-model="formChangeEmail.email"
                              :disabled="!formChangeEmail.useCustom"></el-input>
                </el-form-item>
                <el-form-item :label="$t('serviceTickets.useCustom')"
                              prop="useCustom">
                    <el-switch v-model="formChangeEmail.useCustom"></el-switch>
                </el-form-item>
                <el-button :key="buttonkey"
                           :disabled="loadingChangeEmail"
                           type="primary"
                           @click.once="save(true)">{{$t('serviceTickets.send')}}</el-button>
                <el-button :disabled="loadingChangeEmail"
                           @click="showChangeEmailDialog = false">{{$t('serviceTickets.cancel')}}</el-button>
            </el-form>
        </el-dialog>
        <el-button :key="buttonkey" type="primary"
                   @click="showChangeEmailDialog = true">{{$t('serviceTickets.yesSaveSend')}}</el-button>
        <el-button :key="buttonkey" @click.once="save(false)">{{$t('serviceTickets.noSaveClose')}}</el-button>
    </el-dialog>
</template>

<script>
    import api from "../api";
    export default {
        name: "send-email-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            loadingChangeEmail: {
                type: Boolean,
                defailt: false,
            },
            formChangeEmail: {
                serviceCompany: null,
                phone: null,
                email: null,
                useCustom: false
            },
        },
        data() {
            return {
                buttonkey:0,
                rulesChangeEmail: {
                    serviceCompany: [
                        {
                            required: true,
                            message: this.$t('common.pleaseSelectServiceCompany'),
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: this.$t('common.pleaseSelectPhone'),
                            trigger: "blur"
                        }
                    ],
                    email: [
                        {
                            type: "email",
                            required: true,
                            message: this.$t('common.pleaseInputCorrectEmailAddress'),
                            trigger: "blur"
                        }
                    ]
                },
                showDialog: this.visible,
                showChangeEmailDialog: false                
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            },
            loadingChangeEmail: function (val) {
                this.loadingChangeEmail = val;
            },
            formChangeEmail: function (val) {
                this.formChangeEmail = val;
            }
        },
        methods: {
            save(sendEmail) {
                var isValid = true;
                if (this.formChangeEmail.useCustom) {
                    this.$refs["formChangeEmail"].validate(validChangeEmail => {
                        if (!validChangeEmail) {
                            isValid = false;
                        }
                    });
                }
                this.showChangeEmailDialog = false;
                this.$emit("dialogClosed");
                this.$emit('save', sendEmail, isValid);
                setTimeout(() => { 
                    this.buttonkey++ 
                }, 1000)
            }
        }
    };
</script>


// WEBPACK FOOTER //
// ClientApp/app/servicetickets/components/SendEmailDialog.vue